import { render, staticRenderFns } from "./ExportStaffInsurance.vue?vue&type=template&id=676247e2"
import script from "./ExportStaffInsurance.vue?vue&type=script&lang=js"
export * from "./ExportStaffInsurance.vue?vue&type=script&lang=js"
import style0 from "./ExportStaffInsurance.vue?vue&type=style&index=0&id=676247e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports